// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:52:16

export default {
  "id": "shop-sorting-2",
  "slug": "shop-sorting-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7037b5a9bd36452ab195486677004120-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7037b5a9bd36452ab195486677004120/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Shop Sorting 2",
      "description": "Love organizing and keeping things tidy? Then Shop Sorting 2 is the perfect game for you! Step into a satisfying sorting puzzle where you arrange and categorize products in a well-stocked store.\nIn Shop Sorting 2, the challenge shifts from organizing specialty goods to managing the variety and chaos of a busy supermarket. Test your skills as you handle groceries, household items, and more. Enjoy rewarding match and sort gameplay, unlock new products, and upgrade your store layout.",
      "instructions": "Drag and place products onto the shelves. Match three identical items to clear them. Organize all the products to complete each level. As you progress, unlock new store layouts and take on even bigger sorting challenges in the supermarket.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "matching",
        "shopping",
        "sorting"
      ]
    },
    "zh-CN": {
      "title": "商店整理2",
      "description": "热爱整理和保持整洁？那么《商店整理2》正是你的完美游戏！踏入一个令人满足的排序谜题，在这里你将安排和分类一个装备齐全的商店中的产品。\n\n在《商店整理2》中，挑战从整理特殊商品转向管理繁忙超市的多样性和混乱。在处理杂货、家居用品等等的过程中测试你的技能。享受令人满意的匹配和排序游戏玩法，解锁新产品，并升级你的商店布局。",
      "instructions": "拖动并放置产品到货架上。匹配三个相同的物品来清除它们。组织所有产品以完成每个关卡。随着游戏的进行，解锁新的店铺布局，并在超市中接受更大的分类挑战。",
      "genres": [
        "谜题"
      ],
      "tags": [
        "匹配",
        "购物",
        "排序"
      ]
    },
    "zh-TW": {
      "title": "商店分類 2",
      "description": "愛整理和保持環境整潔？那麼《商店整理2》正是您的心頭好！步入了這款令人滿足的排序益智遊戲，在擁有豐富商品的商店中整理和分類商品。\n在《商店整理2》中，挑戰從整理特色商品轉變為管理繁忙超市的多元化和混亂。當您處理食品雜貨、家庭用品等時，檢驗您的技巧。享受獎勵性的匹配和排序遊戲玩法，解鎖新商品，並升級您的商店佈局。",
      "instructions": "將產品拖動並放置到架上。匹配三個相同的物品以清除它們。整理所有產品以完成每個關卡。隨著進展，解鎖新的商店佈局，並在超市中挑戰更大的分類挑戰。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "配對",
        "購物",
        "分類"
      ]
    },
    "zh-HK": {
      "title": "商店排序2",
      "description": "喜歡整理和保持環境整潔？那麼《Shop Sorting 2》就是為你量身打造的遊戲！步入一個滿足感的分類謎題，在一家商品充滿的商店中安排和分類產品。\n在《Shop Sorting 2》中，挑戰從整理特色商品轉變為管理繁雜的超市。當你處理雜貨、家居用品等時，測試你的技巧。享受獎勵性的配對和分類遊戲玩法，解鎖新產品，並升級你的商店佈局。",
      "instructions": "拖移並將產品放置於架上。匹配三個相同的物品以清除它們。整理所有產品以完成每個關卡。隨著進度，解鎖新商店佈局並在超市接受更大的分類挑戰。",
      "genres": [
        "謎題"
      ],
      "tags": [
        "配對",
        "購物",
        "分類"
      ]
    },
    "ja": {
      "title": "ショップソート2",
      "description": "整理と整頓が好きですか？それなら「Shop Sorting 2」がお気に入りになるでしょう！豊富に商品が並ぶ店の中で商品を整理・分類する満足感のあるパズルに飛び込みましょう。\n\n「Shop Sorting 2」では、挑戦は特別商品の整理から、賑やかなスーパーマーケットの多様性と混沌を管理する方向へと変わります。食料品、家電品など、様々な商品を扱ってあなたのスキルを試してみてください。報酬のあるマッチングと整理のゲームプレイを楽しみながら、新しい商品を解禁し、店のレイアウトをアップグレードしましょう。",
      "instructions": "商品をドラッグして棚に配置。同じアイテムを3つまとめてクリアします。すべての商品を整理して、レベルをクリアします。進むにつれて、新しい店舗レイアウトを解除し、スーパーマーケットでより大きな整理課題に挑戦します。",
      "genres": [
        "パズル"
      ],
      "tags": [
        "マッチング",
        "ショッピング",
        "ソートリング"
      ]
    },
    "ko": {
      "title": "상점 정렬 2",
      "description": "좋아하는 취미로 정리하고 깨끗하게 유지하는가? 그렇다면 Shop Sorting 2는 완벽한 게임이다! 방대한 재고를 가진 상점에서 제품을 정리하고 분류하는 만족스러운 정리 퍼즐에 발을 들여다보세요.\n\nShop Sorting 2에서는 도전이 특산품을 정리하는 것에서 바쁜 슈퍼마켓의 다양성과 혼란을 관리하는 데 이동합니다. 가게 상품, 가정용품 등을 다루며 자신의 능력을 테스트하세요. 보상 있는 매칭과 정리 게임 플레이를 즐기고, 새로운 제품을 해금하고 상점 레이아웃을 업그레이드하세요.",
      "instructions": "드래그하여 제품을 책상에 배치하세요. 같은 아이템을 세 개 일치시켜 제거하세요. 모든 제품을 정리하여 각 레벨을 완료하세요. 진행하면서 새로운 상점 레이아웃을 해금하고 슈퍼마켓에서 더 큰 정리 도전을 맞이하세요.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "매칭",
        "쇼핑",
        "정렬"
      ]
    },
    "fr": {
      "title": "Classement de Magasin 2",
      "description": "Aimez organiser et entretenir l'ordre ? Alors Shop Sorting 2 est le jeu parfait pour vous ! Plongez dans un puzzle de classification satisfaisant où vous rangez et catégorisez des produits dans un magasin bien approvisionné.\nDans Shop Sorting 2, le défi passe de l'organisation des produits spécialisés à la gestion de la variété et du chaos d'un supermarché animé. Testez vos compétences en manipulant des produits alimentaires, des articles ménagers et bien plus encore. Profitez du gameplay amusant et gratifiant, débloquez de nouveaux produits et améliorez l'aménagement de votre magasin.",
      "instructions": "Faites glisser et placez les produits sur les étagères. Cochez trois articles identiques pour les éliminer. Organisez tous les produits pour terminer chaque niveau. Au fur et à mesure de votre progression, débloquez de nouveaux aménagements de magasins et affrontez des défis de tri encore plus grands dans le supermarché.",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "matching - correspondance\nshopping - shopping\nsorting - tri"
      ]
    }
  }
};
